export default {
  total: state => state.offers.total,
  results: state => state.offers.results,
  facets: state => state.offers.facets,
  filter: state => state.offers.filter,
  slides: state => state.slides.slides,
  regions: state => state.regions,
  countries: state => state.countriesWithCities.countries,
  cities: state => state.countriesWithCities.cities,
  isSeeAllFilter: state => state.isSeeAllFilter,
  isSeeAllFilterEurope: state => state.isSeeAllFilterEurope,
  emptySliders: state => state.emptySliders,
  currentRegion: state => code => {
    return state.regions.regions.find(region => region.code === code)
  },
  currentCountry: state => code => {
    return state.countriesWithCities.countries.find(region => region.code === code)
  },
  currentCity: state => code => {
    return state.countriesWithCities.cities.find(region => region.code === code)
  },
  countriesWithCities: state => state.countriesWithCities,
  registeredOfferCodes: state => state.registeredOfferCodes,
  locationOrRegion: state => state.locationOrRegion
}
